import { makeStyles } from '@material-ui/core/styles';

export const reportPermissionsStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    maxWidth: '100%',
    margin: 'auto',
    padding: theme.spacing(2)
  },
  userRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  }
}));
